import React, { useEffect } from "react";
import Loadable from "react-loadable";
import { useDispatch, useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ConfigProvider, notification } from "antd";
import localeEn from "antd/lib/locale/en_US";
import localeEs from "antd/lib/locale/es_ES";
import localePt from "antd/lib/locale/pt_PT";

import { Loader, ThemeLoader } from "./components/base";

import { antdTheme, styledTheme } from "./utils/themes";
import { updateMessage } from "./services/redux/actions/theme";
import { ThemeProvider } from "styled-components";

import "./App.less";

const locales = {
    en: localeEn,
    es: localeEs,
    pt: localePt,
};

const loading = () => <Loader />;

const Login = Loadable({
    loader: () => import("./pages/Auth/Login/Login"),
    loading,
});

const MainLayout = Loadable({
    loader: () => import("./layouts/MainLayout/MainLayout"),
    loading,
});

// data router so router data APIs (e.g. useBlocker) are available to pages
const router = createBrowserRouter([
    { path: "/login", element: <Login /> },
    { path: "/*", element: <MainLayout /> },
]);



const App = () => {
    const dispatch = useDispatch();
    const [api, contextHolder] = notification.useNotification();

    const { language, theme, message } = useSelector((state) => state.theme);

    useEffect(() => {
        document.body.className = `theme-${theme}`;
    }, [theme]);

    useEffect(() => {
        if (message.content) {
            api[message.type]({
                message: message.type.toUpperCase(),
                description: message.content,
                onClose: () => dispatch(updateMessage(null, null)),
            });
        }
    }, [message.content]); // eslint-disable-line

    return (
        <React.Fragment>
            {contextHolder}

            <ThemeLoader />

            <ConfigProvider theme={antdTheme[theme]} locale={locales[language] || localeEs}>
                <ThemeProvider theme={styledTheme[theme]}>
                    <RouterProvider router={router} />
                </ThemeProvider>
            </ConfigProvider>
        </React.Fragment>
    );
};

export default App;
